module.exports = __webpack_public_path__ + "static/our-services-244cd094d813b24442ad66f5546e5bc5.jpg";